import { FormOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import DrawerToolbarButton from './DrawerToolbarButton';

function EditButton() {
  const canEdit = store.creative?.mounted;

  return (
    <DrawerToolbarButton
      disabled={!canEdit}
      panelType={PanelViews.AD}
      label="Properties"
      icon={<FormOutlined />}
    />
  );
}

export default observer(EditButton);
